<template>
    <div class="sub-assignment-page">
        <div class="page-container" role="tablist" >
            <draggable group="parts"
                       :list="roadmapIn.steps"
                       handle=".single-step-drag-handle"
                       ghost-class="drag-ghost">
                    <span v-for="step in roadmapIn.steps" class="steps-page" :key="step.id">
                        <design-2021-roadmap-create-step-component
                            :roadmap-in="roadmapIn"
                            :step-in="step"
                        ></design-2021-roadmap-create-step-component>
                    </span>
            </draggable>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: "design-2021-roadmap-edit-steps-details-component",
    props:[
        'roadmapIn'
    ],
    components: {
        draggable,
    }
}
</script>

<style scoped lang="scss">

</style>
